export default __webpack_public_path__ + "static/media/Q2-2.bd86a7ce.jpg";